const typography = {
	fontFamily: ['Inter', 'Roboto'].join(','),
	h1: {
		fontWeight: 500,
		fontSize: 35,
		letterSpacing: '-0.24px',
		color: '#546e7a',
	},
	h2: {
		fontWeight: 500,
		fontSize: 29,
		letterSpacing: '-0.24px',
		color: '#546e7a',
	},
	h3: {
		fontWeight: 500,
		fontSize: 24,
		letterSpacing: '-0.06px',
		color: '#546e7a',
	},
	h4: {
		fontWeight: 500,
		fontSize: 20,
		letterSpacing: '-0.06px',
		color: '#546e7a',
	},
	h5: {
		fontWeight: 500,
		fontSize: 16,
		letterSpacing: '-0.05px',
		color: '#546e7a',
	},
	h6: {
		fontWeight: 500,
		fontSize: 14,
		letterSpacing: '-0.05px',
		color: '#546e7a',
	},
	overline: {
		fontWeight: 500,
	},
};

export default typography;
